import axios from 'axios';
import BusinessUnit from '../entity/business-unit.entity';
import Datasource from '../entity/datasource.entity';
import ResultCenter from '../entity/result-center.entity';

export default class BusinessUnitService {
  public static getAll(): Promise<BusinessUnit[]> {
    return axios.get('/api/v1/business-units')
      .then((response: any) => BusinessUnit.ofList(response.data));
  }

  public static getResultCenters(businessUnitId: string): Promise<ResultCenter[]> {
    if (!businessUnitId) {
      return new Promise((resolve) => resolve([]));
    }
    return axios.get(`/api/v1/business-units/${businessUnitId}/result-centers`)
      .then((response: any) => ResultCenter.ofList(response.data));
  }

  public static getDatasources(businessUnitId: string): Promise<Datasource[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/datasources`)
      .then((response: any) => Datasource.ofList(response.data));
  }

  public static getAllResponsibleEmails(): Promise<string[]> {
    return axios.get('/api/v1/business-units/responsibles/emails')
      .then((response: any) => response.data);
  }

  public static switchEnableNotifyCancellation(businessUnitId: string,
    notifyCancellation: boolean): Promise<Datasource[]> {
    const body = { active: notifyCancellation };
    return axios.put(`/api/v1/business-units/${businessUnitId}/switch-notify-cancellation`, body);
  }

  public static switchChargeInactivatedInstances(businessUnitId: string,
    active: boolean): Promise<any> {
    const body = { active };
    return axios.put(`/api/v1/business-units/${businessUnitId}/switch-charge-inactivated-instances`, body);
  }

  public static isChargeInactivatedInstancesEnabled(businessUnitId: string): Promise<boolean> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/charge-inactivated-instances-enabled`)
      .then((response: any) => response.data);
  }

  public static showCustomDateAllowed(businessUnitId: string): Promise<Boolean> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/custom-date-allowed`)
      .then((response: any) => response.data);
  }

  public static getMacros(businessUnitId: string): Promise<string[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/macros`)
      .then((response: any) => response.data);
  }
}
